import { TypeProgram_metaWithoutUnresolvableLinksResponse } from "@2u-landing-pages/types";
import { formatDate } from "./formatting";

const META_REGEX = /\{\{meta\.([\w\.]+)\}\}/g;

/**
 * Resolves `{{meta.*}}` tokens in a template string against a Program Meta entry.
 * Single source of truth shared by useMetadataParser (prop path) and
 * useStringInterpolation (context path) so the resolution logic can't drift.
 */
export const parseMetaTemplate = (
  template: string,
  metadata?: TypeProgram_metaWithoutUnresolvableLinksResponse | null
): string => {
  if (!metadata) return template;

  return template.replace(META_REGEX, (_, path) => {
    try {
      const parts = path.split(".");
      let value: any = metadata.fields;

      for (const part of parts) {
        if (value === undefined || value === null) {
          throw new Error(`Invalid path: ${path}`);
        }
        if (part.includes("primary_")) {
          value = value[part].value;
        } else {
          value = value[part];
        }
      }

      // Format date fields from ISO format to readable format
      if ((path.endsWith("start_date") || path.endsWith("application_deadline")) && value) {
        return formatDate(value);
      }

      return value?.toString() || "";
    } catch (error) {
      console.error(`Error parsing metadata path "${path}":`, error);
      return "";
    }
  });
};
